$(function() {
    if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        $('.sublayoutFeatured #divMathCallouts .etcalloutstack-listitem h2').each(function () {
            $(this).addClass("featuredh2ie");
        });
    }

    $('.sublayoutFeatured #divMathCallouts .etcalloutstack-listitem h2').each(function () {
        $(this).append("&nbsp;" + "<img src='/App_Themes/Default/Images/TI%20ScienceNspired/chevrons.png' />");
    });
});